import { createSlice, PayloadAction, createSelector } from "@reduxjs/toolkit";

import { initialState, RootState, UserState } from "./types";

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    signIn: (state) => {
      state.status = UserState.SIGNIN;
      state.authenticated = true;
    },
    updateNotAuthenticated: (state) => {
      state.status = UserState.NOT_AUTHENTICATED;
      state.authenticated = false;
    },
    logout: (state) => {
      state.authenticated = false;
      state.error = undefined;
      state.status = UserState.SIGNOUT;
      state.fetchedLoginGql = false;
    },
    initKeycloakSuccess: (state) => {
      state.kcReady = true;
    },
    initKeycloakFailure: (state, action: PayloadAction<string>) => {
      state.kcReady = false;
      state.error = action.payload;
    },
    updateFetchLoginGql: (state) => {
      state.fetchedLoginGql = true;
    },
  },
});
export const {
  logout,
  signIn,
  initKeycloakSuccess,
  initKeycloakFailure,
  updateFetchLoginGql,
  updateNotAuthenticated,
} = authSlice.actions;

/* ----------------- Select Function ----------------- */
const selectAuthState = (state: RootState) => state.auth;
export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state) => state.authenticated,
);
export const selectAuthStatus = createSelector(
  selectAuthState,
  (state) => state.status,
);
export const selectKcReady = createSelector(
  selectAuthState,
  (state) => state.kcReady,
);
export const selectFetchLoginGql = createSelector(
  selectAuthState,
  (state) => state.fetchedLoginGql,
);

export default authSlice.reducer;
